import { CodeStatus, MaritimeEventType, PermitCategory, PermitType } from "./common/enums";

import CalendarAcceptedMarker from "../assets/permitMarkers/calendar-accepted-marker.svg";
import CalendarActiveMarker from "../assets/permitMarkers/calendar-active-marker.svg";
import CalendarArchivedMarker from "../assets/permitMarkers/calendar-archived-marker.svg";
import CalendarRegisteredMarker from "../assets/permitMarkers/calendar-registered-marker.svg";
import CalendarRejectedMarker from "../assets/permitMarkers/calendar-rejected-marker.svg";

import CraneAcceptedMarker from "../assets/permitMarkers/crane-accepted-marker.svg";
import CraneActiveMarker from "../assets/permitMarkers/crane-active-marker.svg";
import CraneArchivedMarker from "../assets/permitMarkers/crane-archived-marker.svg";
import CraneRegisteredMarker from "../assets/permitMarkers/crane-registered-marker.svg";
import CraneRejectedMarker from "../assets/permitMarkers/crane-rejected-marker.svg";

import CraneToolsAcceptedMarker from "../assets/permitMarkers/crane-tools-accepted-marker.svg";
import CraneToolsActiveMarker from "../assets/permitMarkers/crane-tools-active-marker.svg";
import CraneToolsArchivedMarker from "../assets/permitMarkers/crane-tools-archived-marker.svg";
import CraneToolsRegisteredMarker from "../assets/permitMarkers/crane-tools-registered-marker.svg";
import CraneToolsRejectedMarker from "../assets/permitMarkers/crane-tools-rejected-marker.svg";

import DiverAcceptedMarker from "../assets/permitMarkers/diver-accepted-marker.svg";
import DiverActiveMarker from "../assets/permitMarkers/diver-active-marker.svg";
import DiverArchivedMarker from "../assets/permitMarkers/diver-archived-marker.svg";
import DiverRegisteredMarker from "../assets/permitMarkers/diver-registered-marker.svg";
import DiverRejectedMarker from "../assets/permitMarkers/diver-rejected-marker.svg";

import GasMaskAcceptedMarker from "../assets/permitMarkers/gas-mask-accepted-marker.svg";
import GasMaskActiveMarker from "../assets/permitMarkers/gas-mask-active-marker.svg";
import GasMaskArchivedMarker from "../assets/permitMarkers/gas-mask-archived-marker.svg";
import GasMaskRegisteredMarker from "../assets/permitMarkers/gas-mask-registered-marker.svg";
import GasMaskRejectedMarker from "../assets/permitMarkers/gas-mask-rejected-marker.svg";

import HandSparklesAcceptedMarker from "../assets/permitMarkers/hand-sparkles-accepted-marker.svg";
import HandSparklesActiveMarker from "../assets/permitMarkers/hand-sparkles-active-marker.svg";
import HandSparklesArchivedMarker from "../assets/permitMarkers/hand-sparkles-archived-marker.svg";
import HandSparklesRegisteredMarker from "../assets/permitMarkers/hand-sparkles-registered-marker.svg";
import HandSparklesRejectedMarker from "../assets/permitMarkers/hand-sparkles-rejected-marker.svg";

import HeatWavesAcceptedMarker from "../assets/permitMarkers/heat-waves-accepted-marker.svg";
import HeatWavesActiveMarker from "../assets/permitMarkers/heat-waves-active-marker.svg";
import HeatWavesArchivedMarker from "../assets/permitMarkers/heat-waves-archived-marker.svg";
import HeatWavesRegisteredMarker from "../assets/permitMarkers/heat-waves-registered-marker.svg";
import HeatWavesRejectedMarker from "../assets/permitMarkers/heat-waves-rejected-marker.svg";

import LaptopAcceptedMarker from "../assets/permitMarkers/laptop-accepted-marker.svg";
import LaptopActiveMarker from "../assets/permitMarkers/laptop-active-marker.svg";
import LaptopArchivedMarker from "../assets/permitMarkers/laptop-archived-marker.svg";
import LaptopRegisteredMarker from "../assets/permitMarkers/laptop-registered-marker.svg";
import LaptopRejectedMarker from "../assets/permitMarkers/laptop-rejected-marker.svg";

import ScrewdriverAcceptedMarker from "../assets/permitMarkers/screwdriver-accepted-marker.svg";
import ScrewdriverActiveMarker from "../assets/permitMarkers/screwdriver-active-marker.svg";
import ScrewdriverArchivedMarker from "../assets/permitMarkers/screwdriver-archived-marker.svg";
import ScrewdriverRegisteredMarker from "../assets/permitMarkers/screwdriver-registered-marker.svg";
import ScrewDriverRejectedMarker from "../assets/permitMarkers/screwdriver-rejected-marker.svg";

import WavesAcceptedMarker from "../assets/permitMarkers/waves-accepted-marker.svg";
import WavesActiveMarker from "../assets/permitMarkers/waves-active-marker.svg";
import WavesArchivedMarker from "../assets/permitMarkers/waves-archived-marker.svg";
import WavesRegisteredMarker from "../assets/permitMarkers/waves-registered-marker.svg";
import WavesRejectedMarker from "../assets/permitMarkers/waves-rejected-marker.svg";

import FireAcceptedMarker from "../assets/permitMarkers/fire-accepted-marker.svg";
import FireActiveMarker from "../assets/permitMarkers/fire-active-marker.svg";
import FireArchivedMarker from "../assets/permitMarkers/fire-archived-marker.svg";
import FireRegisteredMarker from "../assets/permitMarkers/fire-registered-marker.svg";
import FireRejectedMarker from "../assets/permitMarkers/fire-rejected-marker.svg";

import WrenchAcceptedMarker from "../assets/permitMarkers/wrench-accepted-marker.svg";
import WrenchActiveMarker from "../assets/permitMarkers/wrench-active-marker.svg";
import WrenchArchivedMarker from "../assets/permitMarkers/wrench-archived-marker.svg";
import WrenchRegisteredMarker from "../assets/permitMarkers/wrench-registered-marker.svg";
import WrenchRejectedMarker from "../assets/permitMarkers/wrench-rejected-marker.svg";

import WrenchCogAcceptedMarker from "../assets/permitMarkers/wrench-cog-accepted-marker.svg";
import WrenchCogActiveMarker from "../assets/permitMarkers/wrench-cog-active-marker.svg";
import WrenchCogArchivedMarker from "../assets/permitMarkers/wrench-cog-archived-marker.svg";
import WrenchCogRegisteredMarker from "../assets/permitMarkers/wrench-cog-registered-marker.svg";
import WrenchCogRejectedMarker from "../assets/permitMarkers/wrench-cog-rejected-marker.svg";

export function getPermitIcon(
    permitName: string,
    permitCategory: string,
    status: string,
    isActive: boolean,
    maritimeEventType?: string
): { markerSrc: any } {
    const markerSrc = getMarkerSrc(permitName, permitCategory, status, isActive, maritimeEventType);
    return {
        markerSrc
    };
}

function getMarkerSrc(
    permitName: string,
    permitCategory: string,
    status: string,
    isActive: boolean,
    maritimeEventType?: string
): string | undefined {
    switch (permitName) {
        case PermitType.EnergyHarbourPermit:
        case PermitType.CoordinationPermit:
        case PermitType.GeneralDepartmentPermit:
            return getPermitCategoryMarkerSrc(permitCategory, status, isActive);
        case PermitType.MaritimeEvent:
            return getMaritimeEventMarkerSrc(maritimeEventType, status, isActive);
        case PermitType.DivingPermit:
            return GetDivingPermitMarkerSrc(status, isActive);
        case PermitType.HotWorkOnShipPermit:
            return getHotWorkOnShipPermitMarkerSrc(status, isActive);
        case PermitType.HullCleaningPermit:
            return getHullCleaningPermitMarkerSrc(status, isActive);
        case PermitType.ShipRepairsPermit:
            return getShipRepairsPermitMarkerSrc(status, isActive);
        case PermitType.UnderWaterWorkPermit:
            return getUnderWaterWorkPermitMarkerSrc(status, isActive);
    }
}

function getPermitCategoryMarkerSrc(permitCategory: string, status: string, isActive: boolean): any {
    switch (permitCategory) {
        case PermitCategory.ColdWork:
        case PermitCategory.Other:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return WrenchRegisteredMarker;
                case CodeStatus.Archived:
                    return WrenchArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? WrenchActiveMarker : WrenchAcceptedMarker;
                case CodeStatus.Rejected:
                    return WrenchRejectedMarker;
            }
            break;
        case PermitCategory.HotWorkCategoryOne:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return FireRegisteredMarker;
                case CodeStatus.Archived:
                    return FireArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? FireActiveMarker : FireAcceptedMarker;
                case CodeStatus.Rejected:
                    return FireRejectedMarker;
            }
            break;
        case PermitCategory.HotWorkCategoryTwo:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return ScrewdriverRegisteredMarker;
                case CodeStatus.Archived:
                    return ScrewdriverArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? ScrewdriverActiveMarker : ScrewdriverAcceptedMarker;
                case CodeStatus.Rejected:
                    return ScrewDriverRejectedMarker;
            }
            break;
        case PermitCategory.HotWorkCategoryThree:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return LaptopRegisteredMarker;
                case CodeStatus.Archived:
                    return LaptopArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? LaptopActiveMarker : LaptopAcceptedMarker;
                case CodeStatus.Rejected:
                    return LaptopRejectedMarker;
            }
            break;
        case PermitCategory.WorkWithRiskOfFlammableLiquidOrGas:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return GasMaskRegisteredMarker;
                case CodeStatus.Archived:
                    return GasMaskArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? GasMaskActiveMarker : GasMaskAcceptedMarker;
                case CodeStatus.Rejected:
                    return GasMaskRejectedMarker;
            }
    }

    console.warn(
        `No marker found for Permit with category ${permitCategory}, status ${status} and isActive ${isActive}`
    );
}
function getMaritimeEventMarkerSrc(
    maritimeEventType: string | undefined,
    status: string,
    isActive: boolean
): string | undefined {
    switch (maritimeEventType) {
        case MaritimeEventType.CraneArmLowered:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return CraneRegisteredMarker;
                case CodeStatus.Archived:
                    return CraneArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? CraneActiveMarker : CraneAcceptedMarker;
                case CodeStatus.Rejected:
                    return CraneRejectedMarker;
            }
            break;
        case MaritimeEventType.CraneService:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return CraneToolsRegisteredMarker;
                case CodeStatus.Archived:
                    return CraneToolsArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? CraneToolsActiveMarker : CraneToolsAcceptedMarker;
                case CodeStatus.Rejected:
                    return CraneToolsRejectedMarker;
            }
            break;
        default:
            switch (status) {
                case CodeStatus.New:
                case CodeStatus.Registered:
                    return CalendarRegisteredMarker;
                case CodeStatus.Archived:
                    return CalendarArchivedMarker;
                case CodeStatus.Accepted:
                    return isActive ? CalendarActiveMarker : CalendarAcceptedMarker;
                case CodeStatus.Rejected:
                    return CalendarRejectedMarker;
            }
    }

    console.warn(
        `No marker found for Maritime Event with type ${maritimeEventType}, status ${status} and isActive ${isActive}`
    );
}

function GetDivingPermitMarkerSrc(status: string, isActive: boolean): string | undefined {
    switch (status) {
        case CodeStatus.New:
        case CodeStatus.Registered:
            return DiverRegisteredMarker;
        case CodeStatus.Archived:
            return DiverArchivedMarker;
        case CodeStatus.Accepted:
            return isActive ? DiverActiveMarker : DiverAcceptedMarker;
        case CodeStatus.Rejected:
            return DiverRejectedMarker;
    }

    console.warn(`No marker found for Diving Permit with status ${status} and isActive ${isActive}`);
}

function getHotWorkOnShipPermitMarkerSrc(status: string, isActive: boolean): string | undefined {
    switch (status) {
        case CodeStatus.New:
        case CodeStatus.Registered:
            return HeatWavesRegisteredMarker;
        case CodeStatus.Archived:
            return HeatWavesArchivedMarker;
        case CodeStatus.Accepted:
            return isActive ? HeatWavesActiveMarker : HeatWavesAcceptedMarker;
        case CodeStatus.Rejected:
            return HeatWavesRejectedMarker;
    }

    console.warn(`No marker found for Hot Work On Ship Permit with status ${status} and isActive ${isActive}`);
}

function getHullCleaningPermitMarkerSrc(status: string, isActive: boolean): string | undefined {
    switch (status) {
        case CodeStatus.New:
        case CodeStatus.Registered:
            return HandSparklesRegisteredMarker;
        case CodeStatus.Archived:
            return HandSparklesArchivedMarker;
        case CodeStatus.Accepted:
            return isActive ? HandSparklesActiveMarker : HandSparklesAcceptedMarker;
        case CodeStatus.Rejected:
            return HandSparklesRejectedMarker;
    }

    console.warn(`No marker found for Hull Cleaning Permit with status ${status} and isActive ${isActive}`);
}

function getShipRepairsPermitMarkerSrc(status: string, isActive: boolean): string | undefined {
    switch (status) {
        case CodeStatus.New:
        case CodeStatus.Registered:
            return WrenchCogRegisteredMarker;
        case CodeStatus.Archived:
            return WrenchCogArchivedMarker;
        case CodeStatus.Accepted:
            return isActive ? WrenchCogActiveMarker : WrenchCogAcceptedMarker;
        case CodeStatus.Rejected:
            return WrenchCogRejectedMarker;
    }

    console.warn(`No marker found for Ship Repairs Permit with status ${status} and isActive ${isActive}`);
}

function getUnderWaterWorkPermitMarkerSrc(status: string, isActive: boolean): string | undefined {
    switch (status) {
        case CodeStatus.New:
        case CodeStatus.Registered:
            return WavesRegisteredMarker;
        case CodeStatus.Archived:
            return WavesArchivedMarker;
        case CodeStatus.Accepted:
            return isActive ? WavesActiveMarker : WavesAcceptedMarker;
        case CodeStatus.Rejected:
            return WavesRejectedMarker;
    }

    console.warn(`No marker found for Under Water Work Permit with status ${status} and isActive ${isActive}`);
}
